// import * as React from 'react';
// import Box from '@mui/material/Box';
// import { useParams } from 'react-router-dom';
// import { getDownloadURL, ref as ref_storage, uploadBytes, uploadBytesResumable } from 'firebase/storage';
// import { useState } from 'react';
// import { auth, app, storage, database, firestore } from '../../Firebase/firebase.config';
// import { GrLinkNext } from 'react-icons/gr';
// import Button from 'react-bootstrap/Button';
// import { Form } from 'react-bootstrap';
// import { useHistory } from 'react-router-dom';
// import { getDatabase, ref, get, set, onValue, child, push, } from 'firebase/database';
// import './License.css'

// import { styled, useTheme } from '@mui/material/styles';
// import Typography from '@mui/material/Typography';

// import SideNav from '../SideNav';
// import { useEffect } from 'react';
// const DrawerHeader = styled('div')(({ theme }) => ({
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'flex-end',
//     padding: theme.spacing(0, 1),
//     // necessary for content to be below app bar
//     ...theme.mixins.toolbar,
// }));





// const License = () => {
//     const { id } = useParams();
//     const database = getDatabase();
//     const [img, setImg] = useState('')
//     const [urlID, setUrl] = useState('')
//     const [url1, setgetUrl1] = useState('')
//     const [url2, setgetUrl2] = useState('')
//     const [url3, setgetUrl3] = useState('')
//     const [url4, setgetUrl4] = useState('')
//     const [url5, setgetUrl5] = useState('')
//     const [url6, setgetUrl6] = useState('')
//     const [text1, setText1] = useState('')
//     const [text2, setText2] = useState('')
//     const [text3, setText3] = useState('')
//     const [text4, setText4] = useState('')
//     const [text5, setText5] = useState('')
//     const [text6, setText6] = useState('')
//     const [description, setDescription] = useState('')
//     const [descriptionTxt, setDescriptionTxt] = useState('')

//     useEffect(() => {
//         console.log(id);

//         // onValue(ref(database, 'Achievement'), (snapshot) =>
//         //     console.log(snapshot.val())
//         // );

//         console.log("Heyy");

//         onValue(ref(database, `License/${id}/1`), (snapshot) => {
//             if (snapshot.exists()) {
//                 setgetUrl1(snapshot.val().url1);
//             } else {
//                 // Handle the case when the data doesn't exist
//                 console.error(`Data for License/${id}/1 does not exist.`);
//             }
//         });

//         onValue(ref(database, `License/${id}/2`), (snapshot) => {
//             if (snapshot.exists()) {
//                 setgetUrl2(snapshot.val().url2);
//             } else {
//                 // Handle the case when the data doesn't exist
//                 console.error(`Data for License/${id}/2 does not exist.`);
//             }
//         });

//         onValue(ref(database, `License/${id}/3`), (snapshot) => {
//             if (snapshot.exists()) {
//                 setgetUrl3(snapshot.val().url3);
//             } else {
//                 // Handle the case when the data doesn't exist
//                 console.error(`Data for License/${id}/3 does not exist.`);
//             }
//         });

//         onValue(ref(database, `License/${id}/4`), (snapshot) => {
//             if (snapshot.exists()) {
//                 setgetUrl4(snapshot.val().url4);
//             } else {
//                 // Handle the case when the data doesn't exist
//                 console.error(`Data for License/${id}/4 does not exist.`);
//             }
//         });

//         onValue(ref(database, `License/${id}/5`), (snapshot) => {
//             if (snapshot.exists()) {
//                 setgetUrl5(snapshot.val().url5);
//             } else {
//                 // Handle the case when the data doesn't exist
//                 console.error(`Data for License/${id}/5 does not exist.`);
//             }
//         });

//         onValue(ref(database, `License/${id}/6`), (snapshot) => {
//             if (snapshot.exists()) {
//                 setgetUrl6(snapshot.val().url6);
//             } else {
//                 // Handle the case when the data doesn't exist
//                 console.error(`Data for License/${id}/6 does not exist.`);
//             }
//         });

//         onValue(ref(database, `License/${id}/description`), (snapshot) => {
//             if (snapshot.exists()) {
//                 setDescriptionTxt(snapshot.val().description);
//             } else {
//                 // Handle the case when the data doesn't exist
//                 console.error(`Data for License/${id}/description does not exist.`);
//             }
//         });







//         console.log("Heyy");

//     }, [])


//     const putData = (key, data) => set(ref(database, key), data);

//     const postListRef = ref(database, `License/${id}`);
//     const newPostRef = push(postListRef);




//     function uploadData() {

//         if (img || text1) {
//             const imgRef = ref_storage(storage, `License/${id}/License/1`);
//             const uploadTask = uploadBytesResumable(imgRef, img);
//             //Handle the promise returned by uploadBytesResumable
//             uploadTask
//                 .then((snapshot) => {
//                     console.log('Upload complete', snapshot);

//                     // Use snapshot.ref instead of data.ref_storage
//                     getDownloadURL(snapshot.ref).then((url) => {
//                         setUrl(url);
//                         console.log('Download URL:', url);
//                         alert("Data uploaded succesfully, Please refresh the page")
//                         putData(`License/${id}/1`, { url1: url })
//                         // putData(`Achievement/${id}/1`, { text1: text1 })
//                         console.log(text1);
//                     });
//                 })
//                 .catch((error) => {
//                     console.error('Error uploading image:', error);
//                 });
//         }
//         else {
//             alert("Please select an image and enter details.");
//         }




//     }

//     function uploadData2() {

//         if (img || text2) {
//             const imgRef = ref_storage(storage, `License/${id}/License/2`);
//             const uploadTask = uploadBytesResumable(imgRef, img);
//             //Handle the promise returned by uploadBytesResumable
//             uploadTask
//                 .then((snapshot) => {
//                     console.log('Upload complete', snapshot);

//                     // Use snapshot.ref instead of data.ref_storage
//                     getDownloadURL(snapshot.ref).then((url) => {
//                         setUrl(url);
//                         console.log('Download URL:', url1);
//                         alert("Data uploaded succesfully, Please refresh the page")
//                         putData(`License/${id}/2`, { url2: url })
//                     });
//                 })
//                 .catch((error) => {
//                     console.error('Error uploading image:', error);
//                 });

//         } else {
//             alert("Please select an image and enter details.");
//         }



//     }

//     function uploadData3() {

//         if (img || text3) {
//             const imgRef = ref_storage(storage, `License/${id}/License/3`);
//             const uploadTask = uploadBytesResumable(imgRef, img);
//             //Handle the promise returned by uploadBytesResumable
//             uploadTask
//                 .then((snapshot) => {
//                     console.log('Upload complete', snapshot);

//                     // Use snapshot.ref instead of data.ref_storage
//                     getDownloadURL(snapshot.ref).then((url) => {
//                         setUrl(url);
//                         console.log('Download URL:', url1);
//                         alert("Data uploaded succesfully, Please refresh the page")
//                         putData(`License/${id}/3`, { url3: url })
//                     });
//                 })
//                 .catch((error) => {
//                     console.error('Error uploading image:', error);
//                 });
//         } else {
//             alert("Please select an image and enter details.");
//         }






//     }


//     function uploadData4() {
//         if (img && text4) {
//             const imgRef = ref_storage(storage, `License/${id}/License/4`);
//             const uploadTask = uploadBytesResumable(imgRef, img);
//             //Handle the promise returned by uploadBytesResumable
//             uploadTask
//                 .then((snapshot) => {
//                     console.log('Upload complete', snapshot);

//                     // Use snapshot.ref instead of data.ref_storage
//                     getDownloadURL(snapshot.ref).then((url) => {
//                         setUrl(url);
//                         console.log('Download URL:', url1);
//                         alert("Data uploaded succesfully, Please refresh the page")
//                         putData(`License/${id}/4`, { url4: url })
//                     });
//                 })
//                 .catch((error) => {
//                     console.error('Error uploading image:', error);
//                 });
//         } else {
//             alert("Please select an image and enter details.");
//         }





//     }




//     const uploadText = () => {
//         console.log(description);
//         putData(`License/${id}/description`, { description: description })
//     }
//     const history = useHistory();

//     const handleNext = () => {
//         history.push(`/Qualification/${id}`)
//     }

//     return (
//         <>
//             <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
//                 <SideNav id={id} />

//                 <div>
//                     <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
//                         <DrawerHeader />
//                         <h2 style={{ color: 'red' }}>Kindly Upload Your Medical License / Active Registration Documents</h2>

//                         <div style={{ display: 'flex' }} className='MainDiv'>

//                             <div style={{ margin: 10 }}>
//                                 <h5>Upload License</h5>
//                                 <input
//                                     type="file"
//                                     onChange={(e) => setImg(e.target.files[0])}
//                                     className='input-background-color'
//                                     name='Licence'

//                                     style={{ width: '100%' }}
//                                 />



//                                 <input type="text" placeholder='Enter details' style={{ width: '100%' }} onChange={e => setText1(e.target.value)} />



//                                 <div className='row' style={{ marginTop: 10 }}>
//                                     <div className='d-flex justify-content-between' style={{ height: '8vh' }}>
//                                         <Button onClick={() => uploadData()} className='' style={{ width: '100%', padding: '0', marginTop: '5', backgroundColor: '#0073cf' }} variant="primary" type="submit">
//                                             Upload 1   <GrLinkNext className='text-white' />
//                                         </Button>
//                                     </div>
//                                 </div>
//                             </div>


//                             <div style={{ margin: 10 }}>
//                                 <h5>Other License 1</h5>
//                                 <input
//                                     type="file"
//                                     onChange={(e) => setImg(e.target.files[0])}
//                                     className='input-background-color'
//                                     name='Licence'

//                                     style={{ width: '100%' }}
//                                 />

//                                 <input type="text" placeholder='Enter details' style={{ width: '100%' }} />
//                                 <div className='row' style={{ marginTop: 10 }}>
//                                     <div className='d-flex justify-content-between' style={{ height: '8vh' }}>
//                                         <Button onClick={() => uploadData2()} className='' style={{ width: '100%', padding: '0', margin: '0', backgroundColor: '#0073cf' }} variant="primary" type="submit">
//                                             Upload 2   <GrLinkNext className='text-white' />
//                                         </Button>
//                                     </div>
//                                 </div>
//                             </div>


//                             <div style={{ margin: 10 }}>
//                                 <h5>Other License 2</h5>
//                                 <input
//                                     type="file"
//                                     onChange={(e) => setImg(e.target.files[0])}
//                                     className='input-background-color'
//                                     name='Licence'

//                                     style={{ width: '100%' }}
//                                 />
//                                 <input type="text" placeholder='Enter details' style={{ width: '100%' }} />

//                                 <div className='row' style={{ marginTop: 10 }}>
//                                     <div className='d-flex justify-content-between' style={{ height: '8vh' }}>
//                                         <Button onClick={() => uploadData3()} className='' style={{ width: '100%', padding: '0', margin: '0', backgroundColor: '#0073cf' }} variant="primary" type="submit">
//                                             Upload 3   <GrLinkNext className='text-white' />
//                                         </Button>
//                                     </div>
//                                 </div>

//                             </div>

//                             {/* <div style={{ margin: 10 }}>
//                                 <h5>Other License 3</h5>
//                                 <input
//                                     type="file"
//                                     onChange={(e) => setImg(e.target.files[0])}
//                                     className='input-background-color'
//                                     name='Licence'

//                                     style={{ width: '100%' }}
//                                 />
//                                 <input type="text" placeholder='Enter details' style={{ width: '100%' }} />

//                                 <div className='row' style={{ marginTop: 10 }}>
//                                     <div className='d-flex justify-content-between' style={{ height: '8vh' }}>
//                                         <Button onClick={() => uploadData4()} className='' style={{ width: '100%', padding: '0', margin: '0', backgroundColor: '#0073cf' }} variant="primary" type="submit">
//                                             Upload 4   <GrLinkNext className='text-white' />
//                                         </Button>
//                                     </div>
//                                 </div>
//                             </div> */}



//                         </div>





//                         <h4>All Documents</h4>
//                         {/* <h4>url {url1}</h4> */}

//                         <div style={{ display: 'flex', backgroundSize: 'cover', }} className='Sub'>
//                             <div style={{ display: 'flex', width: '50%', }} className='smallDiv'>

//                                 {
//                                     url1 !== '' ? <div style={{ border: '1px solid #000', marginBottom: 20, marginRight: 20, padding: 20, display: 'flex' }}>
//                                         <img src={url1} style={{ width: '150px', height: '200px', cursor: 'pointer', borderWidth: 1, borderColor: 'black', objectFit: 'cover' }} alt="Logo" onClick={() => window.open(url1, "_blank")} />


//                                     </div> : null
//                                 }

//                                 {
//                                     url2 !== '' ? <div style={{ border: '1px solid #000', marginBottom: 20, marginRight: 20, padding: 20, display: 'flex' }}>
//                                         <img src={url2} style={{ width: '150px', height: '200px', cursor: 'pointer', borderWidth: 1, borderColor: 'black', objectFit: 'cover' }} alt="Logo" onClick={() => window.open(url2, "_blank")} />


//                                     </div>
//                                         : null
//                                 }

//                                 {
//                                     url3 !== '' ? <div style={{ border: '1px solid #000', marginBottom: 20, marginRight: 20, padding: 20, display: 'flex' }}>
//                                         <img src={url3} style={{ width: '150px', height: '200px', cursor: 'pointer', borderWidth: 1, borderColor: 'black', objectFit: 'cover' }} alt="Logo" onClick={() => window.open(url3, "_blank")} />


//                                     </div> : null
//                                 }

//                                 {
//                                     url4 !== '' ? <div style={{ border: '1px solid #000', marginBottom: 20, marginRight: 20, padding: 20, display: 'flex' }}>
//                                         <img src={url4} style={{ width: '150px', height: '200px', cursor: 'pointer', borderWidth: 1, borderColor: 'black', objectFit: 'cover' }} alt="Logo" onClick={() => window.open(url4, "_blank")} />


//                                     </div> : null
//                                 }

//                             </div>

//                         </div>


//                     </Box>

//                     <Button
//                         variant='primary'
//                         onClick={handleNext}
//                         style={{ width: '5rem', marginTop: '2rem', marginLeft: '3rem' }}
//                     >
//                         Next
//                     </Button>
//                 </div>
//             </Box>
//         </>
//     )
// }

// export default License;

import * as React from 'react';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import { getDownloadURL, ref as ref_storage, uploadBytesResumable } from 'firebase/storage';
import { useState, useEffect } from 'react';
import { auth, app, storage, database, firestore } from '../../Firebase/firebase.config';
import { GrLinkNext } from 'react-icons/gr';
import { FiPlus, FiX, FiUpload } from 'react-icons/fi';
import Button from 'react-bootstrap/Button';
import { Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { getDatabase, ref, get, set, onValue, child, push } from 'firebase/database';
import { validateFile, ALLOWED_TYPES, MAX_FILE_SIZE_MB } from '../utils/Uploadvalidation';
import './License.css';

import { styled, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import SideNav from '../SideNav';

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

// A single license slot's shape:
// { id, file, text, status: 'idle' | 'uploading' | 'done' | 'error', url }
const makeBlock = (id) => ({ id, file: null, text: '', status: 'idle', url: '' });

const License = () => {
    const { id } = useParams();
    const database = getDatabase();

    // Dynamic list of license upload blocks — starts with just one.
    const [blocks, setBlocks] = useState([makeBlock(1)]);
    const nextBlockId = React.useRef(2);

    // Existing uploaded licenses pulled from Firebase (read-only gallery)
    const [savedLicenses, setSavedLicenses] = useState([]);
    const [description, setDescription] = useState('');

    useEffect(() => {
        // Listen to every numbered slot under License/{id} and collect any
        // that exist into a single gallery array, same data shape as before.
        const slotKeys = [1, 2, 3, 4, 5, 6];
        const unsubscribers = slotKeys.map((slot) =>
            onValue(ref(database, `License/${id}/${slot}`), (snapshot) => {
                if (snapshot.exists()) {
                    const url = snapshot.val()[`url${slot}`];
                    setSavedLicenses((prev) => {
                        const withoutThisSlot = prev.filter((item) => item.slot !== slot);
                        return url
                            ? [...withoutThisSlot, { slot, url }].sort((a, b) => a.slot - b.slot)
                            : withoutThisSlot;
                    });
                }
            })
        );

        onValue(ref(database, `License/${id}/description`), (snapshot) => {
            if (snapshot.exists()) {
                setDescription(snapshot.val().description || '');
            }
        });

        return () => unsubscribers.forEach((unsub) => unsub && unsub());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const putData = (key, data) => set(ref(database, key), data);

    // ── Block helpers ──
    const updateBlock = (blockId, patch) => {
        setBlocks((prev) => prev.map((b) => (b.id === blockId ? { ...b, ...patch } : b)));
    };

    const addBlock = () => {
        setBlocks((prev) => [...prev, makeBlock(nextBlockId.current++)]);
    };

    const removeBlock = (blockId) => {
        setBlocks((prev) => prev.filter((b) => b.id !== blockId));
    };

    // Each block uploads independently to the next free numbered slot in
    // Firebase, so existing saved licenses are never overwritten.
    const uploadBlock = (blockId) => {
        const block = blocks.find((b) => b.id === blockId);
        if (!block || !block.file) {
            alert('Please select an image to upload.');
            return;
        }

        // Safety-net re-check right before the network call — this is what
        // actually protects the Storage quota even if the file somehow
        // bypassed the input-level check above.
        const result = validateFile(block.file);
        if (!result.valid) {
            alert(result.reason);
            return;
        }

        const usedSlots = savedLicenses.map((l) => l.slot);
        let targetSlot = 1;
        while (usedSlots.includes(targetSlot)) targetSlot++;

        updateBlock(blockId, { status: 'uploading' });

        const imgRef = ref_storage(storage, `License/${id}/License/${targetSlot}`);
        const uploadTask = uploadBytesResumable(imgRef, block.file);

        uploadTask
            .then((snapshot) => getDownloadURL(snapshot.ref))
            .then((url) => {
                putData(`License/${id}/${targetSlot}`, { [`url${targetSlot}`]: url });
                updateBlock(blockId, { status: 'done', url });
            })
            .catch((error) => {
                console.error('Error uploading license:', error);
                updateBlock(blockId, { status: 'error' });
                alert('Upload failed. Please try again.');
            });
    };

    const history = useHistory();
    const handleNext = () => {
        history.push(`/Achievement/${id}`);
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <SideNav id={id} />

            <Box component="main" className="license-page" sx={{ flexGrow: 1, p: { xs: 2, sm: 3 } }}>
                <DrawerHeader />

                <h2 className="license-heading">
                    Kindly Upload Your Medical License / Active Registration Documents
                </h2>

                <div className="license-blocks">
                    {blocks.map((block, index) => (
                        <div className="license-block" key={block.id}>
                            <div className="license-block-header">
                                <h5>{index === 0 ? 'Upload License' : `Additional License ${index}`}</h5>
                                {blocks.length > 1 && (
                                    <button
                                        type="button"
                                        className="license-remove-btn"
                                        onClick={() => removeBlock(block.id)}
                                        aria-label="Remove this license block"
                                    >
                                        <FiX />
                                    </button>
                                )}
                            </div>

                            <label className="license-file-input">
                                <input
                                    type="file"
                                    accept={ALLOWED_TYPES.join(',')}
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        const result = validateFile(file);
                                        if (!result.valid) {
                                            alert(result.reason);
                                            e.target.value = ''; // reset the input so a bad file isn't "stuck" selected
                                            updateBlock(block.id, { file: null });
                                            return;
                                        }
                                        updateBlock(block.id, { file });
                                    }}
                                />
                                <span>{block.file ? block.file.name : 'Choose file…'}</span>
                            </label>
                            <p className="license-file-hint">
                                JPG, PNG, or WEBP — max {MAX_FILE_SIZE_MB} MB
                            </p>

                            <input
                                type="text"
                                className="license-text-input"
                                placeholder="Enter details"
                                value={block.text}
                                onChange={(e) => updateBlock(block.id, { text: e.target.value })}
                            />

                            <Button
                                onClick={() => uploadBlock(block.id)}
                                disabled={block.status === 'uploading'}
                                className="license-upload-btn"
                                variant="primary"
                                type="button"
                            >
                                {block.status === 'uploading' ? (
                                    'Uploading…'
                                ) : block.status === 'done' ? (
                                    'Uploaded ✓'
                                ) : (
                                    <>
                                        Upload <FiUpload />
                                    </>
                                )}
                            </Button>
                        </div>
                    ))}
                </div>

                <button type="button" className="license-add-btn" onClick={addBlock}>
                    <FiPlus /> Add More
                </button>

                <h4 className="license-docs-heading">All Documents</h4>

                <div className="license-gallery">
                    {savedLicenses.length === 0 ? (
                        <p className="license-empty">No documents uploaded yet.</p>
                    ) : (
                        savedLicenses.map(({ slot, url }) => (
                            <div className="license-thumb" key={slot}>
                                <img
                                    src={url}
                                    alt={`License ${slot}`}
                                    onClick={() => window.open(url, '_blank')}
                                />
                            </div>
                        ))
                    )}
                </div>

                <Button variant="primary" onClick={handleNext} className="license-next-btn">
                    Next <GrLinkNext />
                </Button>
            </Box>
        </Box>
    );
};

export default License;